<router-outlet></router-outlet>

<app-conf2-sign-in-failure *ngIf="conf2SignInFailure$ | async as reason" [reason]="reason"></app-conf2-sign-in-failure>

<app-mic-volume></app-mic-volume>
<app-icons></app-icons>
<app-notice-feature-notice></app-notice-feature-notice>
<app-ui-popover></app-ui-popover>
<app-ui-svg></app-ui-svg>
